import { getBuyoverTiersText } from '../features/cart/buyoverTiers'
import {
  type Discount,
  DiscountType,
} from '../components/Pricing/types/discount.types'
import { calculateDiscountPercent, formatPriceWithPrecision } from './utils'

type TranslateFn = (key: string, params?: Record<string, unknown>) => string

export function getDiscountSubtitle(
  discount: Discount,
  originalBundlePrice: number | undefined,
  t: TranslateFn,
  currency?: string,
  // allTiers renders the full buyover ladder instead of the applied-tier copy.
  { allTiers = false } = {}
): string {
  switch (discount.type) {
    case DiscountType.BUYOVER: {
      const tiers = discount.metadata.tiers
      if (allTiers && tiers.length > 1) {
        return getBuyoverTiersText(tiers, t, (price) =>
          formatPriceWithPrecision(
            price,
            currency ?? discount.metadata.bundleCurrency
          )
        )
      }
      if (discount.metadata.buyOverPrice > 0) {
        return t(
          'order.checkout.payment_summary_rows.buy_over_percent_off_orders_over_price',
          {
            v1: discount.metadata.buyOverDiscount,
            v2: formatPriceWithPrecision(
              discount.metadata.buyOverPrice,
              currency ?? discount.metadata.bundleCurrency
            ),
          }
        )
      }
      return t(
        'order.checkout.payment_summary_rows.buy_over_percent_off_orders',
        { v1: discount.metadata.buyOverDiscount }
      )
    }
    case DiscountType.BUYXGETY: {
      const percentOff = Math.round(
        (discount.metadata.get * 100) /
          (discount.metadata.buy + discount.metadata.get)
      )
      return t(
        'general.promo_code_success_dialog.size_and_material_disclaimer',
        { v1: `${percentOff}` }
      )
    }
    case DiscountType.PERCENT: {
      return t(
        'general.promo_code_success_dialog.size_and_material_disclaimer',
        { v1: `${discount.discount.percent_off}` }
      )
    }
    case DiscountType.BUNDLE: {
      const percentOff = calculateDiscountPercent(
        discount.metadata.bundlePrice,
        originalBundlePrice
      )
      return t(
        'general.promo_code_success_dialog.size_and_material_disclaimer',
        { v1: `${percentOff}` }
      )
    }
    default:
      return ''
  }
}
